// 合并打包后的图片（js文件）
import '@/page/pageImg'
import '@/assets/assetsImg'
